import { render } from "./DocumentFormPreview.vue?vue&type=template&id=c05963d4&scoped=true"
import script from "./DocumentFormPreview.vue?vue&type=script&lang=js"
export * from "./DocumentFormPreview.vue?vue&type=script&lang=js"

import "./DocumentFormPreview.vue?vue&type=style&index=0&id=c05963d4&scoped=true&lang=scss"

import exportComponent from "/tmp/5e119732-5ebd-42f7-baa8-4916aa59fc29/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c05963d4"]])

export default __exports__